import groupBy from 'lodash/groupBy';
import { GanttEntryWorkingTypesEnum } from '@thinknet-gmbh/platform-common';

import { mapBuilder } from 'src/common/helpers/common.helpers';

export const buildGanttData = (
  employees: any,
  ganttRecords: any,
  timeStripes: any,
  absenceReasons: any,
  employeesWorkingHours: any
) => {
  const employeesWorkingHoursMap = groupBy(employeesWorkingHours, 'employeeId');
  const ganttRecordsMap = groupBy(ganttRecords, 'employeeId');
  const timeStripesByIdMap = mapBuilder(timeStripes);
  const absenceReasonsByIdMap = mapBuilder(absenceReasons);

  return employees.map((employee: any, index: number) => {
    const employeeRecords = ganttRecordsMap[employee._id] || [];
    const workingHours = employeesWorkingHoursMap[employee._id] || [];
    const employeeRecordsWithSources = employeeRecords.map(record => {
      const newEntries = record.entries.map(({ sourceId, ...entry }: any) => ({
        ...entry,
        source: timeStripesByIdMap[sourceId] || absenceReasonsByIdMap[sourceId],
      }));

      return {
        ...record,
        entries: newEntries.sort((a: any, b: any) => {
          if (a.orderPriority) {
            return a.orderPriority - b.orderPriority;
          }

          // first entries with END_WORKING type
          if (a.workingType === GanttEntryWorkingTypesEnum.END_WORKING) {
            return -1;
          }

          // in end entries with range days planning
          if (a.startDateString !== a.endDateString) {
            return 1;
          }

          return b.workingType === GanttEntryWorkingTypesEnum.END_WORKING ? 0 : -1;
        }),
      };
    });

    return {
      employee: { ...employee, workingHours, index },
      ganttRecords: employeeRecordsWithSources,
      ganttRecordsByDateMap: mapBuilder(employeeRecordsWithSources, 'dateString'),
    };
  });
};
